import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function cancelOrderApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.cancelorderapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value: "https://demo-sop.jtfulfillment.cn/gateway/edi/order/cancel"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/gateway/edi/order/cancel"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/order/cancel"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value: "https://openapi.jtfulfillment.cn/gateway/edi/order/cancel"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "VARCHAR",
              describe: "apiDocDesc.customeridDesc391"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "VARCHAR",
              describe: "apiDocDesc.warehouseCodeDesc392"
            },
            {
              name: "orderType",
              type: "INT",
              require: "Y",
              normal: "INT",
              describe: "apiDocDesc.orderTypeDesc393"
            },
            {
              name: "orderCode",
              type: "VARCHAR",
              require: "Y",
              normal: "VARCHAR",
              describe: "apiDocDesc.orderCodeDesc394"
            },
            {
              name: "cancelReason",
              type: "VARCHAR",
              require: "Y",
              normal: "VARCHAR",
              describe: "apiDocDesc.cancelReasonDesc395"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc396"
            },
            {
              name: "errorCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.errorCodeDesc397"
            },
            {
              name: "message",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.messageDesc398"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        orderType: "THRK",
        customerid: "MABANG-UAT",
        orderCode: "2024110100009",
        cancelReason: "测试",
        warehouseCode: "SH.001"
      },
      //返回示例
      responseCodes: [
        {
          title: "返回成功示例",
          value: {
            traceId: "439a2d462751bf088cdde76ad3f0f5aa",
            responseitems: [
              {
                success: "true",
                reason: "入库单取消成功",
                errorMsg: "入库单取消成功"
              }
            ],
            logisticproviderid: "YL"
          }
        },
        {
          title: "返回失败示例",
          value: {
            traceId: "439a2d462751bf088cdde76ad3f0f5aa",
            responseitems: [
              {
                success: "false",
                reason: "入库单取消失败",
                errorMsg: "入库单取消失败"
              }
            ],
            logisticproviderid: "YL"
          }
        }
      ]
    }
  };
}
